import { Linkedin, Mail, MapPin, ArrowUpRight } from "lucide-react";

const NAV = {
  Company: [
    { l: "About", h: "#about" },
    { l: "Leadership", h: "#leadership" },
    { l: "Why Tirupati", h: "#why" },
    { l: "Certifications", h: "#certifications" },
  ],
  Capabilities: [
    { l: "Facilities", h: "#facilities" },
    { l: "Products", h: "#products" },
    { l: "Logistics", h: "#logistics" },
    { l: "Quality Lab", h: "#quality" },
  ],
  Engage: [
    { l: "Request RFQ", h: "#rfq" },
    { l: "Contact", h: "#contact" },
    { l: "Clients", h: "#clients" },
    { l: "Global Reach", h: "#global-reach" },
  ],
};

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-navy text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 bp-grid opacity-25 pointer-events-none" />
      <div className="absolute -top-32 right-0 h-80 w-80 rounded-full bg-brand-earth/15 blur-3xl pointer-events-none" />

      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="flex items-center">
              <img
                src="/logo-v2-light.png"
                alt="Tirupati Global Sourcing Company"
                className="h-16 lg:h-20 w-auto object-contain"
              />
            </div>

            <p className="mt-6 text-white/75 leading-relaxed max-w-sm">
              Engineering-led sourcing and manufacturing partner for OEMs across
              Europe, the UK, USA and the Middle East. ISO 9001 · IATF 16949 ·
              VDA 6.3.
            </p>

            <div className="mt-7 flex items-center gap-3">
              <a
                data-testid="footer-linkedin"
                href="#"
                className="h-10 w-10 flex items-center justify-center bg-white/10 hover:bg-white/20 transition border border-white/15"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                data-testid="footer-email"
                href="mailto:marketing@tgscglobal.com"
                className="h-10 px-4 flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 transition border border-white/15 text-sm"
              >
                <Mail className="h-4 w-4" /> marketing@tgscglobal.com
              </a>
              <a
                data-testid="footer-website"
                href="https://www.tirupatigroups.co.in"
                target="_blank"
                rel="noreferrer"
                className="h-10 px-4 flex items-center justify-center gap-2 bg-brand-orange/15 hover:bg-brand-orange/25 transition border border-brand-orange/30 text-sm text-white"
              >
                tirupatigroups.co.in
              </a>
            </div>
          </div>

          {Object.entries(NAV).map(([k, items]) => (
            <div key={k} className="lg:col-span-2">
              <div className="text-[11px] uppercase tracking-[0.22em] text-brand-orange font-semibold">
                {k}
              </div>
              <ul className="mt-5 space-y-3">
                {items.map((i) => (
                  <li key={i.l}>
                    <a
                      data-testid={`footer-${i.l.toLowerCase().replace(/\s+/g, '-')}`}
                      href={i.h}
                      className="text-white/80 hover:text-white text-sm flex items-center gap-1.5 group"
                    >
                      {i.l}
                      <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-brand-orange font-semibold">
              Certified
            </div>
            <ul className="mt-5 space-y-3 text-white/80 text-sm">
              <li>ISO 9001:2015</li>
              <li>IATF 16949:2016</li>
              <li>VDA 6.3</li>
            </ul>
            <div className="mt-6 flex items-center gap-2 text-white/70 text-sm">
              <MapPin className="h-4 w-4 text-brand-orange" /> Pune, Maharashtra · India
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
          <div className="text-white/55 text-xs">
            © {new Date().getFullYear()} Tirupati Global Sourcing Company. All rights
            reserved.
          </div>
          <div className="flex items-center gap-6 text-white/55 text-xs">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <a href="#" className="hover:text-white">Cookie Notice</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
